module.exports = __webpack_public_path__ + "static/media/manage_notification.4cb7079c.svg";